import ProgressIndicator from '@/components/ProgressIndicator';
import Head from 'next/head';
import s from './HelpCenterIframe.module.scss';

const HelpCenterIframe: React.FC = () => (
  <div className={s.helpCenterContainer}>
    <Head>
      <title>Help Center · Glade Dashboard</title>
    </Head>
    <ProgressIndicator className={s.progress} />
    <iframe src="https://glade.frontkb.com/en" className={s.helpCenterIframe} />
  </div>
);

export default HelpCenterIframe;
